export default "__VITE_ASSET__BxKjOren__"